/**
 *  Video plugin or system module implementation.
 *  Same interface with video provider from embedded magcore.
 */

'use strict';

/* eslint max-lines-per-function: 0 */
/* eslint camelcase: 0 */

var gettextWrapper = require('mag-gettext'),
    Provider = require('./provider'),
    provider = {};


function sortByQuality ( array ) {
    var list = [];

    array.forEach(function ( item ) {
        if ( item.type === 'video' ) {
            list.push(item);
        }
    });

    list.sort(function ( itemA, itemB ) {
        if ( !itemB.quality ) {
            return 0;
        }

        if ( !itemA.quality ) {
            return -1;
        }

        return itemB.quality.width - itemA.quality.width;
    });

    return list;
}


function getLauncherProvider ( configProvider, ready ) {
    var gettext = gettextWrapper.gettext,
        query = {
            limit: 10,
            sortby: 'added'
        },
        api = configProvider.api,
        path = configProvider.path + 'img/' + screen.height + '/';

    Provider.prototype.getList(query, function ( error, data ) {
        var config;

        if ( !error && data.length ) {
            config = {
                provider: provider,
                data: data.map(function ( video ) {
                    var meta = [],
                        index = 0,
                        icon, images, genres;

                    genres = video.genres.map(function ( genre ) {
                        return genre.name;
                    });

                    if ( video.age ) {
                        meta.push(video.age);
                    }

                    if ( video.year ) {
                        meta.push(video.year_end ? video.year + ' - ' + video.year_end : video.year);
                    }

                    if ( video.duration ) {
                        meta.push(video.duration + ' ' + gettext('min'));
                    }

                    if ( video.rating_kinopoisk ) {
                        meta.push('kinopoisk ' + video.rating_kinopoisk);
                    }

                    if ( video.rating_imdb ) {
                        meta.push('IMDB ' + video.rating_imdb);
                    }

                    if ( (video.censored || (video.category && video.category.censored)) && !core.accessControl.state ) {
                        icon = {
                            normal: path + 'parents-control.png',
                            active: path + 'parents-control-focus.png'
                        };
                    } else if ( video.cover ) {
                        images = {
                            normal: core.stalker.host + video.cover,
                            active: core.stalker.host + video.cover
                        };
                    } else {
                        icon = {
                            normal: path + 'film-placeholder.png',
                            active: path + 'film-placeholder-focus.png'
                        };
                    }

                    return {
                        id: video.id,
                        layout: api.layouts.video,
                        geometry: api.geometry.horizontal,
                        data: {
                            name: video.name ? video.name : video.original_name,
                            description: genres.join(', '),
                            icon: icon,
                            image: images,
                            meta: meta,
                            video: video,
                            url: function ( callback ) {
                                var files;

                                if ( video.is_tv_series ) {
                                    video.getSeasons(function ( error, seasons ) {
                                        var season;

                                        if ( !error && seasons.length ) {
                                            season = seasons[0];
                                            if ( video.last_watched_season_id ) {
                                                for ( index = 0; index < seasons.length; index++ ) {
                                                    if ( seasons[index].id === video.last_watched_season_id ) {
                                                        season = seasons[index];

                                                        break;
                                                    }
                                                }
                                            }
                                            video.getSeries(season.id, function ( seriesError, seriesList ) {
                                                var series;

                                                if ( !seriesError && seriesList.length ) {
                                                    if ( video.last_watched_episode_id ) {
                                                        for ( index = 0; index < seriesList.length; index++ ) {
                                                            if ( seriesList[index].id === video.last_watched_episode_id ) {
                                                                series = seriesList[index];
                                                                break;
                                                            }
                                                        }
                                                    } else {
                                                        series = seriesList[0];
                                                    }


                                                    if ( series.files && series.files.length ) {
                                                        files = sortByQuality(series.files);
                                                        if ( files.length ) {
                                                            if ( files[0].url ) {
                                                                callback(false, files[0].url);
                                                            } else {
                                                                video.getUrl(files[0].id, callback);
                                                            }
                                                        }
                                                    } else {
                                                        video.getEpisode(
                                                            {
                                                                seasonId: season.id,
                                                                episodeId: series[index].id
                                                            },
                                                            function ( error, episode ) {
                                                                if ( !error ) {
                                                                    files = sortByQuality(episode.files);
                                                                    if ( files.length ) {
                                                                        if ( files[0].url ) {
                                                                            callback(false, files[0].url);
                                                                        } else {
                                                                            video.getUrl(files[0].id, callback);
                                                                        }
                                                                    } else {
                                                                        callback(true);
                                                                    }
                                                                }
                                                            }
                                                        );
                                                    }

                                                }
                                            });
                                        }

                                    });
                                } else if ( video.files.length ) {
                                    files = sortByQuality(video.files);
                                    if ( files.length ) {
                                        if ( files[0].url ) {
                                            callback(false, files[0].url);
                                        } else {
                                            video.getUrl(files[0].id, callback);
                                        }
                                    }
                                } else {
                                    callback(true);
                                }
                            }

                        },
                        onClick: function () {
                            var intentConfig = {
                                action: 'videoClub',
                                mime: 'info',
                                data: this.data.video
                            };

                            if ( (video.censored || (video.category && video.category.censored)) && !core.accessControl.state ) {
                                core.accessControl.request(function ( error ) {
                                    if ( !error ) {
                                        core.intent(intentConfig);
                                    }
                                });
                            } else {
                                core.intent(intentConfig);
                            }

                        }
                    };
                })
            };

            config.data.push(
                {
                    layout: api.layouts.video,
                    geometry: api.geometry.horizontal,
                    data: {
                        name: gettext('See more'),
                        icon: {
                            normal: path + 'see-more.png',
                            active: path + 'see-more-focus.png'
                        }
                    },
                    onClick: function () {
                        core.intent({
                            action: 'videoClub',
                            mime: ''
                        });
                    }
                }
            );

            ready(false, config);
        } else {
            ready(!!error, {
                provider: provider,
                data: []
            });
        }
    });
}

provider.search = function ( config, callback ) {
    callback(true);
};


module.exports = {
    onAppInit: function ( config, callback ) {
        callback(null, new Provider());
    },

    onContentBoardInit: function ( config, done ) {
        gettextWrapper.load({
            name: core.environment.language,
            path: config.path + 'lang'
        }, function () {
            getLauncherProvider(config, done);
        });
    }
};
